import { render, staticRenderFns } from "./popup-certificate-edit.vue?vue&type=template&id=1f2a7720&scoped=true&"
import script from "./popup-certificate-edit.vue?vue&type=script&lang=js&"
export * from "./popup-certificate-edit.vue?vue&type=script&lang=js&"
import style0 from "./popup-certificate-edit.vue?vue&type=style&index=0&id=1f2a7720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a7720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
